module.exports = __webpack_public_path__ + "lr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lr.svg
// module id = 663
// module chunks = 0